/** Harte Weiterleitung zum Zahlungsanbieter. Eigene Datei, weil jsdom `window.location.assign` nicht
 *  ersetzen lässt — so bleibt der Redirect im Test mockbar (vi.mock('./redirect')). */
export function redirectToProvider(url: string): void {
  window.location.assign(url)
}
